import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import SearchBar from './SearchBar';
import * as sortableListActions from '../../../actions/common/sortableListActions';

export class SearchBarContainer extends Component {

    constructor(props) {
        super(props);
        this.onChange = this.onChange.bind(this);
    }

    onChange(searchText) {
        this.props.actions.updateList(
            this.props.listId,
            this.props.loadDataAction,
            'id',
            'ASC',
            [1],
            searchText,
            !!this.props.sortableList.withDeleted,
            this.props.sortableList.portalId || ''
        );
    }

    render() {
        return <SearchBar onChange={this.onChange} initialSearchText={this.props.sortableList.search || ''}/>;
    }

}

function mapStateToProps(state, ownProps) {
    return {
        sortableList: state.sortableList[ownProps.listId] || {withDeleted: true},
    };
}

const mapDispatchToProps = (dispatch) => {
    return {
        actions: bindActionCreators(
            Object.assign(
                {},
                sortableListActions
            ), dispatch
        )
    }

};

export default connect(mapStateToProps, mapDispatchToProps)(SearchBarContainer);


// WEBPACK FOOTER //
// ./web/src/components/common/searchbar/SearchBarContainer.jsx